import { Component, input } from '@angular/core';
import { LinkSharedComponent, LinkVariant } from '@unity/shared/composed/link-shared/link-shared.component';
import { UnityRouteUrlTrees } from '@unity/utils/types';

export interface LinkOptions {
  bold?: boolean;
}

@Component({
  selector: 'unity-link-button-shared',
  standalone: true,
  imports: [LinkSharedComponent],
  templateUrl: './link-button-shared.component.html',
  styleUrl: './link-button-shared.component.scss',
})
export class LinkButtonSharedComponent {
  public readonly $displayText = input.required<string>({ alias: 'displayText' });
  public readonly $link = input.required<UnityRouteUrlTrees>({ alias: 'link' });
  public readonly $variants = input<LinkVariant[]>([], { alias: 'variants' });
}
